export default {
  cnh: {},
  cnhs: []
}
